/**
 * Mocked resumable chat data for preview/mocked flows.
 * Used when the chatbot is in mocked mode to show resumable chat modal.
 */

import type { ActiveOpenChat, VerifyChatOpenDto } from '@/common/api/models.pleased';

/**
 * Create mocked resumable chat data
 */
export const createMockedResumableChat = (): ActiveOpenChat => ({
  id: 99999,
  chatStatus: 'OPEN',
  firebaseToken: 'mocked-firebase-token-12345',
  customerId: 12345,
  customerName: 'John Doe',
  subject: 'Payment Issue - Transaction Failed',
  assigneeId: 67890,
  assigneeName: 'Support Agent',
  groupId: 1,
  brandId: 1,
  ticketId: 54321,
});

/**
 * Create mocked chat verification data
 */
export const createMockedVerifyChatOpen = (): VerifyChatOpenDto => ({
  canResume: true,
  ticketId: 54321,
  inActiveConversation: false,
});
